// extracted by mini-css-extract-plugin
module.exports = {"container":"TournamentFantasyBanner_container__3CzfS","button":"TournamentFantasyBanner_button__2w7F5"};